import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c57e94ac"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "input"
};
import Activity from '@/common/components/Activity.vue';
// import Header from '@/common/components/Header.vue';
import ScreenScrollView from '@/common/components/ScreenScroll/ScreenScrollView.vue';
import TransitionRouteView from '@/common/components/TransitionRouteView.vue';
import { getQueryParam } from '@/common/util/getUrlParam';
import { useNavigation } from '@/common/util/navigation';
import { useLoading } from '@/common/util/useLoading';
import FeedbackFormItem from '@/components/FeedbackFormItem.vue';
import QaPicker from '@/components/QaPicker.vue';
import { getApiFeedbackType, postApiFeedbackAdd } from '@/service/api';
import { getDictContactType, EnumContactType } from '@/util/dict';
import AuthUploader from '@/common/components/AuthUploader.vue';
import { reactive, ref } from 'vue';
import { validator, validatorRule } from '@/common/util/validator';
import { useApiToState } from '@/common/util/useApiToState';
import { AppException } from '@/common/util/exception';
import { fileUploader } from '@/common/util/fileUploader';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _DictContactType$0$va, _DictContactType$;
    var _useNavigation = useNavigation(),
      toReplace = _useNavigation.toReplace;
    var _useLoading = useLoading(),
      _useLoading2 = _slicedToArray(_useLoading, 2),
      loading = _useLoading2[0],
      handler = _useLoading2[1];
    var files = ref([]);
    var DEFAULT_LANGUAGE = 'zh-CN';
    var DEFAULT_REGION = 'CN';
    var getQueryValue = function getQueryValue(key) {
      var paramValue = getQueryParam(key);
      console.log(paramValue, 'paramValueparamValue');
      if (paramValue) return paramValue;
      if (paramValue === '') return '';
      if (key === 'language' || key === 'region') {
        return window.sessionStorage.getItem("query:".concat(key)) || '';
      }
      return '';
    };
    var language = getQueryValue('language') || DEFAULT_LANGUAGE;
    var region = getQueryValue('region') || DEFAULT_REGION;
    console.log(region, 'regionregion');
    var DictContactType = getDictContactType(region);
    var isShowUpload = window.isShowUpload;
    console.log(isShowUpload, 'isShowUploadSub');
    var state = reactive({
      appId: window.appId,
      userName: window.nickname,
      openId: window.openid,
      appVersion: window.clientVersion,
      phoneModel: window.clientInfo,
      os: window.os,
      osVersion: window.osVersion,
      netType: window.netType,
      feedbackTypeId: 0,
      content: '',
      url: '',
      contactType: (_DictContactType$0$va = (_DictContactType$ = DictContactType[0]) === null || _DictContactType$ === void 0 ? void 0 : _DictContactType$.value) !== null && _DictContactType$0$va !== void 0 ? _DictContactType$0$va : EnumContactType.Email,
      contact: '',
      ua: window.navigator.userAgent,
      extend: window.customInfo,
      language: language,
      region: region
    });
    var toSubmit = function toSubmit() {
      handler(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var urls;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(options.value.length > 0 && !state.feedbackTypeId)) {
                _context.next = 2;
                break;
              }
              throw new AppException(t('chooseFeedbackType'));
            case 2:
              _context.next = 4;
              return validator(state, {
                content: [['required', t('contentRequired')], ['min:5', t('contentMin5')]]
              });
            case 4:
              if (state.contactType === EnumContactType.Mobile && EnumContactType.Mobile) {
                validatorRule.mobile(state.contact, t('mobileInvalid'));
              }
              if (state.contactType === EnumContactType.Email && state.contact) {
                validatorRule.email(state.contact, t('emailInvalid'));
              }
              _context.next = 8;
              return fileUploader(files.value.map(function (file) {
                return file.file;
              }));
            case 8:
              urls = _context.sent;
              state.url = urls.join(',');
              _context.next = 12;
              return postApiFeedbackAdd(state);
            case 12:
              toReplace('/submit/success');
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    };
    // 获取反馈类型
    var _useApiToState = useApiToState(function () {
        return getApiFeedbackType({
          appId: window.appId,
          openId: window.openid
        }).then(function (list) {
          return (list || []).map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
        });
      }),
      _useApiToState2 = _slicedToArray(_useApiToState, 1),
      options = _useApiToState2[0];
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_radio = _resolveComponent("van-radio");
      var _component_van_radio_group = _resolveComponent("van-radio-group");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createBlock(Activity, {
        "class": "SubmitView"
      }, {
        overlay: _withCtx(function () {
          return [_createVNode(TransitionRouteView)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(ScreenScrollView, null, {
            "default": _withCtx(function () {
              return [_unref(options) && _unref(options).length > 0 ? (_openBlock(), _createBlock(QaPicker, {
                key: 0,
                title: _unref(t)('feedbackType'),
                modelValue: _unref(state).feedbackTypeId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(state).feedbackTypeId = $event;
                }),
                options: _unref(options)
              }, null, 8, ["title", "modelValue", "options"])) : _createCommentVNode("", true), _createVNode(FeedbackFormItem, {
                title: _unref(t)('feedbackDescRequired'),
                style: {
                  "margin-top": "24px"
                }
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(_component_van_field, {
                    type: "textarea",
                    placeholder: _unref(t)('feedbackDescPlaceholder'),
                    modelValue: _unref(state).content,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(state).content = $event;
                    })
                  }, null, 8, ["placeholder", "modelValue"])];
                }),
                _: 1
              }, 8, ["title"]), _createVNode(FeedbackFormItem, {
                title: _unref(t)('contactMethod'),
                style: {
                  "margin-top": "24px"
                }
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(_component_van_radio_group, {
                    modelValue: _unref(state).contactType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(state).contactType = $event;
                    }),
                    direction: "horizontal"
                  }, {
                    "default": _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DictContactType), function (item) {
                        return _openBlock(), _createBlock(_component_van_radio, {
                          name: item.value
                        }, {
                          "default": _withCtx(function () {
                            return [_createTextVNode(_toDisplayString(item.label), 1)];
                          }),
                          _: 2
                        }, 1032, ["name"]);
                      }), 256))];
                    }),
                    _: 1
                  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_field, {
                    placeholder: _unref(t)('contactPlaceholder'),
                    modelValue: _unref(state).contact,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(state).contact = $event;
                    })
                  }, null, 8, ["placeholder", "modelValue"])])];
                }),
                _: 1
              }, 8, ["title"]), _unref(isShowUpload) ? (_openBlock(), _createBlock(FeedbackFormItem, {
                key: 1,
                title: _unref(t)('uploadImagesMax3'),
                style: {
                  "margin-top": "24px"
                }
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(AuthUploader, {
                    value: files.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
                      return files.value = $event;
                    }),
                    "max-count": 3
                  }, null, 8, ["value"])];
                }),
                _: 1
              }, 8, ["title"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _createVNode(_component_van_button, {
            "class": "button",
            onClick: toSubmit,
            loading: _unref(loading),
            block: ""
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)('submit')), 1)];
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        _: 1
      });
    };
  }
});